package br.com.texeratx.boardgametimeapp.domain.usecases.games

import br.com.texeratx.boardgametimeapp.data.model.game.GameModeDTO
import br.com.texeratx.boardgametimeapp.data.repository.GameRepository

class GetGameModesUseCase(
    private val repository: GameRepository
) {
    suspend operator fun invoke(): Result<List<GameModeDTO>> =
        repository.getGameModes()
}
